export function teamCodeRole(role) {
  if (['coach', 'assistant_coach'].includes(role)) return 'coach';
  return ['player', 'parent'].includes(role) ? role : null;
}

export function teamCodePayload(form, { role, mode, user, registerChild }) {
  const session = mode === 'session';
  const first = form.first_name.trim() || (session ? user?.first_name || '' : '');
  const last = form.last_name.trim() || (session ? user?.last_name || '' : '');
  return {
    use_session: session,
    ...(session ? {} : { email: form.email.trim().toLowerCase(), password: form.password }),
    first_name: first, last_name: last, phone: form.phone.trim() || null,
    birthdate: role === 'player' ? form.birthdate : null,
    register_child: role === 'parent' && registerChild,
    child_first_name: role === 'parent' && registerChild ? form.child_first_name.trim() : '',
    child_last_name: role === 'parent' && registerChild ? form.child_last_name.trim() : '',
    child_birthdate: role === 'parent' && registerChild ? form.child_birthdate : null,
    policy_accepted: form.policy_accepted, gdpr_consent: form.gdpr_consent,
  };
}

export function teamCodeError(error, sv) {
  const detail = error?.response?.data?.detail;
  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    return { code: detail.code || '', message: (sv ? detail.message : detail.message_en) || detail.message || '' };
  }
  if (error?.response?.status === 429) return { code: 'rate_limit', message: sv ? 'För många försök. Vänta en stund.' : 'Too many attempts. Please wait a few minutes.' };
  if (error?.response?.status === 422) return { code: 'validation', message: sv ? 'Kontrollera att uppgifterna är rätt ifyllda.' : 'Check the details you entered.' };
  return { code: '', message: typeof detail === 'string' ? detail : (sv ? 'Det gick inte att ansluta. Försök igen.' : 'Unable to join. Please try again.') };
}
